import { Button, DatePicker, Modal } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import { format } from "date-fns";
import { Dayjs } from "dayjs";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { api } from "../../config";
import { AuthenticationState } from "../../interfaces/users";
import { downloadCsv } from "./MassExportModal";

interface SalesReportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SalesReportModal = ({
  isOpen,
  onClose,
}: SalesReportModalProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const { RangePicker } = DatePicker;
  const [start, setStart] = useState<Dayjs | null>();
  const [end, setEnd] = useState<Dayjs | null>();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setStart(null);
    setEnd(null);
    onClose();
  };

  const handleGenerate = async () => {
    if (!start || !end) return toast.error("Selecione o período corretamente");

    try {
      setLoading(true);
      const data = await api(token).get(
        `tickets/sales-report?start=${format(
          start.toDate(),
          "yyyy-MM-dd"
        )}&end=${format(end.toDate(), "yyyy-MM-dd")}`
      );

      downloadCsv(data, "relatorio-de-vendas.csv");
      handleClose();
    } catch (error) {
      toast.error("Ocorreu um erro ao gerar o relatório");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      onCancel={handleClose}
      footer={() => (
        <Button
          loading={loading}
          onClick={handleGenerate}
          variant="solid"
          color="primary"
        >
          Gerar
        </Button>
      )}
    >
      <p>Período:</p>
      <RangePicker
        className="w-full"
        locale={locale}
        value={[start, end]}
        format="DD-MM-YYYY"
        onChange={(e) => {
          if (e?.length) {
            setStart(e?.[0]);
            setEnd(e?.[1]);
          }
        }}
      />
    </Modal>
  );
};
